//@flow
import { connect } from 'react-redux';
import type { DispatchProps } from './RoamingFrame';
import RoamingFrame from './RoamingFrame';
import { fetchRoamingBundles } from '../../../../modules/Dashboard';
import { setRoamingPackage } from '../../../../modules/International/Roaming/actions';
import config from '../../../../config';
import { getRoamingGroupCountries } from '../../../../lib/country-utils.js';
import I18n from '../../../../lib/i18n';

const mapDispatchToProps = (dispatch, ownProps): DispatchProps => ({
  onPress: () => {
    dispatch(fetchRoamingBundles());
    const zoneCountries = getRoamingGroupCountries(
      config.iddCountries,
      ownProps.zone.includes('ROAM_LIKE_HOME') ? ownProps.zone : `ZONE_${ownProps.zone}`
    );
    dispatch(setRoamingPackage(zoneCountries[0], true));
  },
  title:
    ownProps.zone === 'ROAM_LIKE_HOME'
      ? I18n.t('RoamingOffer.RoamLikeHome.offerName')
      : ownProps.zone === 'EXTENDED_ROAM_LIKE_HOME'
      ? I18n.t('RoamingOffer.ExtendedRoamLikeHome.offerName')
      : I18n.t('RoamingOffer.RoamingPackage.offerName', { zone: ownProps.zone }),
  displayDonut: ownProps.status === 'ROAMING' && !ownProps.zone.toString().includes('ROAM_LIKE_HOME'),
  totalRoamingPacks:
    !!ownProps.totalRoamingPacks && ownProps.totalRoamingPacks > 1 ? `${ownProps.totalRoamingPacks}x ` : null,
});

export default connect(null, mapDispatchToProps)(RoamingFrame);
